export enum CustomerUnitpriceTypeEnum {
  RETAIL_PRICE = '1',
  SALES_UNIT_PRICE = '2',
}

export const CustomerUnitpriceType = [
  { label: '上代', value: CustomerUnitpriceTypeEnum.RETAIL_PRICE },
  { label: '売上原価', value: CustomerUnitpriceTypeEnum.SALES_UNIT_PRICE },
];
